<template>
  <CChartLine
    :datasets="defaultDatasets"
    :labels="chartLabels"
   :options="computedOptions"
  />
</template>

<script>
import { CChartLine } from 'vue-chartjs-new' 
import {  deepObjectsMerge } from '@coreui/utils/src'
export default {
  name: 'CChartLineTwoSets',
  components: { CChartLine },
  props: {
    ...CChartLine.props,
    // borderColor: {
    //   type: String,
    //   default: 'rgba(255,255,255,.55)'
    // },
    // backgroundColor: {
    //   type: String,
    //   default: 'transparent'
    // },
    defaultDatasets: {
      type: Array,
      
    },
    chartLabels: {
      type: Array|String,
      
    },
    label: {
      type: String,
      default: function () {
    return this.$t('dashBoard.cChartLineSimple.sales')
      }
    },
    pointed: Boolean,
    pointHoverBackgroundColor: String
  },
  computed: {
   defaultOptions () {
      return {
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            display: true
          }],
          yAxes: [{
            display: true
          }]
        }
      }
    },
    
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    }
  }
}
</script>
